import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';

import './style.scss';

import visa from './visa.png';
import mastercard from './mastercard.png';

import { openCookieSettings } from '../../utils/cookieConsent';
import { siteData } from '../../data/siteData';

const InstagramIcon = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.1705 4.60539e-07H24.8295C29.1609 -2.45699e-05 32.5756 -4.41968e-05 35.289 0.293935C38.065 0.594703 40.3444 1.2224 42.298 2.64178C43.4723 3.49496 44.505 4.52766 45.3582 5.70197C46.7776 7.65557 47.4053 9.93496 47.7061 12.711C48 15.4244 48 18.8391 48 23.1704V24.8296C48 29.1609 48 32.5756 47.7061 35.289C47.4053 38.065 46.7776 40.3444 45.3582 42.298C44.505 43.4723 43.4723 44.505 42.298 45.3582C40.3444 46.7776 38.065 47.4053 35.289 47.7061C32.5756 48 29.1609 48 24.8296 48H23.1704C18.8391 48 15.4244 48 12.711 47.7061C9.93496 47.4053 7.65557 46.7776 5.70197 45.3582C4.52766 44.505 3.49496 43.4723 2.64178 42.298C1.2224 40.3444 0.594703 38.065 0.293935 35.289C-4.41968e-05 32.5756 -2.45699e-05 29.1609 4.60554e-07 24.8295V23.1705C-2.45699e-05 18.8391 -4.41968e-05 15.4244 0.293935 12.711C0.594703 9.93496 1.2224 7.65557 2.64178 5.70197C3.49496 4.52766 4.52766 3.49496 5.70197 2.64178C7.65557 1.2224 9.93496 0.594703 12.711 0.293935C15.4244 -4.41968e-05 18.8391 -2.45699e-05 23.1705 4.60539e-07ZM13.144 4.29025C10.7099 4.55397 9.21886 5.05523 8.06469 5.89378C7.23164 6.49904 6.49904 7.23164 5.89378 8.06469C5.05523 9.21886 4.55397 10.7099 4.29025 13.144C4.02246 15.6157 4.01971 18.8127 4.01971 23.2906V24.7094C4.01971 29.1873 4.02246 32.3843 4.29025 34.856C4.55397 37.2901 5.05523 38.7811 5.89378 39.9353C6.49904 40.7684 7.23164 41.501 8.06469 42.1062C9.21886 42.9448 10.7099 43.446 13.144 43.7097C15.6157 43.9775 18.8127 43.9803 23.2906 43.9803H24.7094C29.1873 43.9803 32.3843 43.9775 34.856 43.7097C37.2901 43.446 38.7811 42.9448 39.9353 42.1062C40.7684 41.501 41.501 40.7684 42.1062 39.9353C42.9448 38.7811 43.446 37.2901 43.7097 34.856C43.9775 32.3843 43.9803 29.1873 43.9803 24.7094V23.2906C43.9803 18.8127 43.9775 15.6157 43.7097 13.144C43.446 10.7099 42.9448 9.21886 42.1062 8.06469C41.501 7.23164 40.7684 6.49904 39.9353 5.89378C38.7811 5.05523 37.2901 4.55397 34.856 4.29025C32.3843 4.02246 29.1873 4.01971 24.7094 4.01971H23.2906C18.8127 4.01971 15.6157 4.02246 13.144 4.29025Z"
            fill="#151515"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 15.8424C19.4947 15.8424 15.8424 19.4947 15.8424 24C15.8424 28.5053 19.4947 32.1576 24 32.1576C28.5053 32.1576 32.1576 28.5053 32.1576 24C32.1576 19.4947 28.5053 15.8424 24 15.8424ZM11.8227 24C11.8227 17.2746 17.2746 11.8227 24 11.8227C30.7254 11.8227 36.1773 17.2746 36.1773 24C36.1773 30.7254 30.7254 36.1773 24 36.1773C17.2746 36.1773 11.8227 30.7254 11.8227 24Z"
            fill="#151515"
        />
        <path
            d="M34.1675 11.1429C34.1675 9.62476 35.3982 8.39409 36.9163 8.39409C38.4344 8.39409 39.665 9.62476 39.665 11.1429C39.665 12.661 38.4344 13.8916 36.9163 13.8916C35.3982 13.8916 34.1675 12.661 34.1675 11.1429Z"
            fill="#151515"
        />
    </svg>
);

const LinkedinIcon = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2622_107)">
            <path
                d="M40 0C42.1217 0 44.1566 0.842855 45.6569 2.34315C47.1571 3.84344 48 5.87827 48 8V40C48 42.1217 47.1571 44.1566 45.6569 45.6569C44.1566 47.1571 42.1217 48 40 48H8C5.87827 48 3.84344 47.1571 2.34315 45.6569C0.842855 44.1566 0 42.1217 0 40V8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0H40ZM40 5.33333H8C7.29276 5.33333 6.61448 5.61429 6.11438 6.11438C5.61429 6.61448 5.33333 7.29276 5.33333 8V40C5.33333 40.7072 5.61429 41.3855 6.11438 41.8856C6.61448 42.3857 7.29276 42.6667 8 42.6667H40C40.7072 42.6667 41.3855 42.3857 41.8856 41.8856C42.3857 41.3855 42.6667 40.7072 42.6667 40V8C42.6667 7.29276 42.3857 6.61448 41.8856 6.11438C41.3855 5.61429 40.7072 5.33333 40 5.33333ZM13.3333 18.6667C13.9865 18.6668 14.6169 18.9065 15.105 19.3406C15.5931 19.7746 15.9049 20.3727 15.9813 21.0213L16 21.3333V34.6667C15.9992 35.3463 15.739 36.0001 15.2724 36.4943C14.8058 36.9885 14.1681 37.286 13.4896 37.3258C12.8111 37.3656 12.143 37.1449 11.6218 36.7086C11.1006 36.2724 10.7656 35.6536 10.6853 34.9787L10.6667 34.6667V21.3333C10.6667 20.6261 10.9476 19.9478 11.4477 19.4477C11.9478 18.9476 12.6261 18.6667 13.3333 18.6667ZM21.3333 16C21.9579 15.9999 22.5626 16.219 23.0421 16.6191C23.5217 17.0192 23.8455 17.5749 23.9573 18.1893C24.4945 17.8791 25.0492 17.6005 25.6187 17.3547C27.3973 16.5947 30.0613 16.176 32.4667 16.9307C33.728 17.3307 34.9947 18.0773 35.9333 19.3493C36.7733 20.4827 37.2267 21.8613 37.3173 23.4107L37.3333 24V34.6667C37.3326 35.3463 37.0723 36.0001 36.6057 36.4943C36.1392 36.9885 35.5015 37.286 34.8229 37.3258C34.1444 37.3656 33.4763 37.1449 32.9551 36.7086C32.4339 36.2724 32.0989 35.6536 32.0187 34.9787L32 34.6667V24C32 23.12 31.7867 22.7093 31.648 22.52C31.4487 22.2727 31.1745 22.0968 30.8667 22.0187C29.9387 21.7253 28.6027 21.88 27.7147 22.2587C26.3813 22.8293 25.16 23.7253 24.328 24.5547L24 24.9067V34.6667C23.9992 35.3463 23.739 36.0001 23.2724 36.4943C22.8058 36.9885 22.1681 37.286 21.4896 37.3258C20.8111 37.3656 20.143 37.1449 19.6218 36.7086C19.1006 36.2724 18.7656 35.6536 18.6853 34.9787L18.6667 34.6667V18.6667C18.6667 17.9594 18.9476 17.2811 19.4477 16.781C19.9478 16.281 20.6261 16 21.3333 16ZM13.3333 10.6667C14.0406 10.6667 14.7189 10.9476 15.219 11.4477C15.719 11.9478 16 12.6261 16 13.3333C16 14.0406 15.719 14.7189 15.219 15.219C14.7189 15.719 14.0406 16 13.3333 16C12.6261 16 11.9478 15.719 11.4477 15.219C10.9476 14.7189 10.6667 14.0406 10.6667 13.3333C10.6667 12.6261 10.9476 11.9478 11.4477 11.4477C11.9478 10.9476 12.6261 10.6667 13.3333 10.6667Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_2622_107">
                <rect width="48" height="48" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const WhatsappIcon = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M38.0996 9.82011C36.2657 7.96832 34.0817 6.50004 31.6746 5.50083C29.2676 4.50162 26.6858 3.99147 24.0796 4.00011C13.1596 4.00011 4.25961 12.9001 4.25961 23.8201C4.25961 27.3201 5.17961 30.7201 6.89961 33.7201L4.09961 44.0001L14.5996 41.2401C17.4996 42.8201 20.7596 43.6601 24.0796 43.6601C34.9996 43.6601 43.8996 34.7601 43.8996 23.8401C43.8996 18.5401 41.8396 13.5601 38.0996 9.82011ZM24.0796 40.3001C21.1196 40.3001 18.2196 39.5001 15.6796 38.0001L15.0796 37.6401L8.83961 39.2801L10.4996 33.2001L10.0996 32.5801C8.4547 29.9542 7.58146 26.9187 7.57961 23.8201C7.57961 14.7401 14.9796 7.34011 24.0596 7.34011C28.4596 7.34011 32.5996 9.06011 35.6996 12.1801C37.2348 13.7078 38.4515 15.5252 39.2789 17.5268C40.1063 19.5283 40.528 21.6743 40.5196 23.8401C40.5596 32.9201 33.1596 40.3001 24.0796 40.3001ZM33.1196 27.9801C32.6196 27.7401 30.1796 26.5401 29.7396 26.3601C29.2796 26.2001 28.9596 26.1201 28.6196 26.6001C28.2796 27.1001 27.3396 28.2201 27.0596 28.5401C26.7796 28.8801 26.4796 28.9201 25.9796 28.6601C25.4796 28.4201 23.8796 27.8801 21.9996 26.2001C20.5196 24.8801 19.5396 23.2601 19.2396 22.7601C18.9596 22.2601 19.1996 22.0001 19.4596 21.7401C19.6796 21.5201 19.9596 21.1601 20.1996 20.8801C20.4396 20.6001 20.5396 20.3801 20.6996 20.0601C20.8596 19.7201 20.7796 19.4401 20.6596 19.2001C20.5396 18.9601 19.5396 16.5201 19.1396 15.5201C18.7396 14.5601 18.3196 14.6801 18.0196 14.6601H17.0596C16.7196 14.6601 16.1996 14.7801 15.7396 15.2801C15.2996 15.7801 14.0196 16.9801 14.0196 19.4201C14.0196 21.8601 15.7996 24.2201 16.0396 24.5401C16.2796 24.8801 19.5396 29.8801 24.4996 32.0201C25.6796 32.5401 26.5996 32.8401 27.3196 33.0601C28.4996 33.4401 29.5796 33.3801 30.4396 33.2601C31.3996 33.1201 33.3796 32.0601 33.7796 30.9001C34.1996 29.7401 34.1996 28.7601 34.0596 28.5401C33.9196 28.3201 33.6196 28.2201 33.1196 27.9801Z"
            fill="black"
        />
    </svg>
);

const Footer = () => {
    const isDesktop = useMediaQuery({ minWidth: 992 });

    const handlePhoneClick = () => {
        window.open(`tel:${siteData.contact.phoneHref}`, '_blank');
    };

    const handleEmailClick = () => {
        window.open(`mailto:${siteData.contact.email}`, '_blank');
    };

    const handleInstagramClick = () => {
        window.open(siteData.links.instagram, '_blank');
    };

    const handleLinkedinClick = () => {
        window.open(siteData.links.linkedin, '_blank');
    };

    const handleWhatsappClick = () => {
        window.open(siteData.links.whatsapp, '_blank');
    };

    const renderLegalLinks = () => (
        <>
            {siteData.footer.legalLinks.map((link) => (
                <Link to={link.path} key={link.path}>
                    {link.label}
                </Link>
            ))}

            <button className="footer__cookie-button" type="button" onClick={openCookieSettings}>
                {siteData.footer.cookieSettings}
            </button>
        </>
    );

    const renderContacts = () => (
        <div className="footer__contacts">
            <button onClick={handlePhoneClick} className="contacts__phone" type="button">
                {siteData.contact.phone}
            </button>

            <button onClick={handleEmailClick} className="contacts__mail" type="button">
                {siteData.contact.email}
            </button>
        </div>
    );

    const renderPayments = () => (
        <div className="footer__inner footer__payments">
            <button className="visa" type="button">
                <img src={visa} alt="Visa" />
            </button>

            <button className="mastercard" type="button">
                <img src={mastercard} alt="Mastercard" />
            </button>
        </div>
    );

    const renderSocials = (showInstagram = true) => (
        <div className="footer__inner footer__socials">
            {showInstagram && (
                <button type="button" aria-label="Instagram" onClick={handleInstagramClick}>
                    <InstagramIcon />
                </button>
            )}

            <button type="button" aria-label="LinkedIn" onClick={handleLinkedinClick}>
                <LinkedinIcon />
            </button>

            <button type="button" aria-label="WhatsApp" onClick={handleWhatsappClick}>
                <WhatsappIcon />
            </button>
        </div>
    );

    return (
        <div className="footer not-sticky">
            <div className="container">
                {isDesktop ? (
                    <div className="footer__wrapper">
                        <div className="footer__item">
                            <h2 className="footer__logo">{siteData.name}</h2>

                            <div className="footer__inner">{renderSocials(false)}</div>

                            <div className="footer__inner footer__links">{renderLegalLinks()}</div>
                        </div>

                        <div className="footer__item">
                            <div className="footer__slug">{siteData.footer.slug}</div>
                            {renderPayments()}
                        </div>

                        <div className="footer__item">{renderContacts()}</div>
                    </div>
                ) : (
                    <div className="footer__wrapper">
                        <div className="footer__item">
                            <h2 className="footer__logo">{siteData.name}</h2>
                            <div className="footer__slug">{siteData.footer.slug}</div>
                        </div>

                        <div className="footer__item">
                            {renderContacts()}
                            {renderSocials(true)}
                        </div>

                        <div className="footer__item">
                            <div className="footer__inner footer__links">{renderLegalLinks()}</div>

                            {renderPayments()}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Footer;
